/*!
 *
 *  page2top.js
 *
 */

var $page2top = $('#Page2Top');
var isVisible = false;
var isMoving = false;

module.exports = function(){
	origin.$window.on('scroll', function(){
		var scrollTop = $(this).scrollTop();

		if( !isVisible && !isMoving && scrollTop > 200 ){
			isMoving = true;
			$page2top.show(0).addClass('st-Page2Top-visible');
			setTimeout(function(){
				isVisible = true;
				isMoving = false;
			}, 500);
		};

		if( isVisible && !isMoving && scrollTop <= 200 ){
			isMoving = true;
			$page2top.removeClass('st-Page2Top-visible');
			setTimeout(function(){
				$page2top.hide(0);
				isVisible = false;
				isMoving = false;
			}, 500);
		};
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/page2top.js
// module id = 21
// module chunks = 0